module.exports = __webpack_public_path__ + "static/media/akvakulturaph.34c16c0a.jpg";